import {Asset} from "common/models";

export const useIsFromSuspense = (formData?: Asset) => {
  return !!formData?.suspense_origin?.draft_fixed_asset_id
}
